import { useState, useEffect } from "react";

export function useScreenSize() {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 641);
  const [isTablet, setIsTablet] = useState(
    window.innerWidth >= 641 && window.innerWidth < 960
  );

  const handleResize = () => {
    setIsMobile(window.innerWidth < 641);
    setIsTablet(window.innerWidth >= 641 && window.innerWidth < 960);
  };

  useEffect(() => {
    window.addEventListener("resize", handleResize);
    handleResize();

    // Cleanup event listener on component unmount
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return { isMobile, isTablet };
}
